export default __webpack_public_path__ + "static/media/device-tilt.5d533fa6.svg";